import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=71c24331"
import script from "./HomeFooter.vue?vue&type=script&lang=ts"
export * from "./HomeFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports